<template>
    <div>
        <el-button type="primary" size="small" class="all_btn" icon="el-icon-plus" @click="reset(1)">添加</el-button>
        <el-button type="success" size="small" class="all_btn" icon="el-icon-edit" @click="reset(2)">编辑</el-button>
        <el-button type="danger" size="small" class="all_btn" icon="el-icon-delete" @click="reset(3)">删除</el-button>
        <el-button type="info" size="small" class="all_btn" icon="el-icon-warning-outline" @click="reset(4)">刷新</el-button>
    </div>
</template>
<script>
export default {
    name:'reset',
    data(){
        return {

        }
    },
    methods:{
        reset(i) {
            this.$emit('clkBtn',i)
        },
    }
}
</script>
<style scoped>
    .all_btn{
        margin: 0 10px 0 0 
    }
</style>